import DateTimeDisplay from "./DateTimeDisplay";
import './App.css';

function App() {
  return (
      <div className="App">
        <DateTimeDisplay />
      </div>
  );
}

export default App;
